<template>
  <div class="navigation-main">
    <ul>
      <li v-for="item in this.$store.getters.mainMenu" :key="item.id" >
        <a :ref="'main-'+item.id"
           :href="item.url"
           :class="[item.hasSub ? subLinkClass : '',item.active ? activeLinkClass : '',item.current ? currentLinkClass : '' ]"
           @click="activateMenuItem($event,item)"
        >
          {{ item.name }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'MainMenu',
  data() {
    return {
      subLinkClass: 'has-sub',
      activeLinkClass: 'active',
      currentLinkClass:'current'
    }
  },
  methods: {
    activateMenuItem(event,item){
      const self = this;
      this.$store.dispatch('menuHasSub',{id:item.id})
          .then(function (res) {
            if (res){
              event.preventDefault();

              if (self.$store.getters.activeMenuElementId === item.id){
                self.$store.commit('hideActiveSubMenu');
              } else {
                const elementInformation = {
                  id:item.id,
                }
                self.$store.commit('setMainMenuElementActiveVersionZero', elementInformation);
              }
            }  else {
              console.log('menu has no sub');
            }
      });

    },
    hideActiveSubMenu(){
      this.$store.commit('hideActiveSubMenu');
    },
    windowResize(){
      const width = window.innerWidth;
      if (width<993){
        this.$store.commit('hideActiveSubMenu');
      }
    }
  },
  created() {

    window.addEventListener("resize", this.windowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResize);
  },
}
</script>


